import React from 'react';
import { Phone } from 'lucide-react';

const TwelveDays = () => {
  return (
    <div className="min-h-screen bg-white">
      

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Main Title */}
        <h2 className="text-3xl font-bold text-[#2f4f2f] mb-6">
          12 Days Tanzania Luxury Safari & Zanzibar Beach Tour
        </h2>

        {/* Main Content with Tour Details */}
        <div className="flex flex-col md:flex-row gap-6">
          {/* Left Side - Main Content */}
          <div className="flex-1">
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Embark on a 12 Days Tanzania Luxury Safari & Zanzibar Beach Tour</strong> and experience Tanzania at its Finest. Explore Tarangire 
              National Park, renowned for its elephant herds, and witness the awe-inspiring Great Migration in Serengeti National Park. Venture into 
              the remarkable <strong>Ngorongoro Crater</strong>, the ultimate destination in Tanzania to witness the Big Five in their 
              natural habitat.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              Conclude your 12-day adventure tour on the pristine beaches of Zanzibar, where the warm turquoise waters and white sands of 
              the Indian Ocean beckon.
            </p>

            {/* Placeholder for Beach Image */}
            <div className="mb-8">
              <div className="bg-[#f5f5f5] h-48 rounded-lg flex items-center justify-center text-gray-500 text-sm">
                <img src="/zanzibar.JPG" alt="5 Days Best of Tanzania Safari" className="w-full h-48 object-cover"/>
                
              </div>
            </div>

            <h3 className="text-2xl font-bold text-[#2f4f2f] mb-4">
              Itinerary for the 12 Days Tanzania Luxury Safari & Zanzibar Beach Tour
            </h3>

            {/* Day 1 */}
            <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
              <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 1: Arrival in Arusha</h4>
              <p className="text-gray-700 leading-relaxed mb-2">
                Upon your arrival at the airport, a representative from African Adventure Travellers will greet you and transport you to your 
                accommodation in Arusha. Here, you will unwind, relax, and gear up for the exciting adventures ahead. Your stay at the Gran Melia 
                Arusha will be a serene and restful experience, offering a peaceful retreat.
              </p>
              <p className="text-sm font-semibold text-[#2f4f2f]">Accommodation: Gran Melia Arusha</p>
            </div>

            {/* Day 2 */}
            <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
              <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 2: Journey to Tarangire National Park</h4>
              <p className="text-gray-700 leading-relaxed mb-2">
                In the morning, our safari driver guide will pick you up from your hotel in Arusha, beginning our journey to Tarangire National Park. 
                We will travel on a well-paved road across the rolling hills of Masai land and finally reach Tarangire National Park. After checking 
                in at our accommodation, we will embark on the early morning game by the roadside, taking in river, baobab trees, and walking savka herds.
              </p>
              <p className="text-gray-700 leading-relaxed mb-2">
                Tarangire National Park, famed for the large elephant herds, also boasts a diverse array of over 550 bird species. The majestic 
                giant roof of our modern safari tent, we will traverse riverine savanna, savannas, and the life-giving Tarangire River, seeking 
                encounters with various wildlife, including giants with others.
              </p>
              <p className="text-sm font-semibold text-[#2f4f2f]">Accommodation: Maramboi Tented Lodge</p>
            </div>

            {/* Day 3 */}
            <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
              <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 3: Transfer to Lake Manyara National Park</h4>
              <p className="text-gray-700 leading-relaxed mb-2">
                After breakfast, we will embark on the next leg of your unforgettable safari to Lake Manyara National Park. Located 120 kilometres 
                west of Arusha, this compact yet diverse park is named after the shallow soda lake that covers approximately 70% of its surface. 
                This park forms part of the ecosystem that hosts the impressive flamingos and more than 400 bird species.
              </p>
              <p className="text-gray-700 leading-relaxed mb-2">
                As we explore the park, we will encounter a variety of wildlife including monkeys, giraffes, zebras, wildebeests, buffaloes, and 
                antelope, as well as populations of graceful tree roosting in the trees. Lake Manyara National Park is celebrated for its varied 
                ecosystems, alkaline soda lake, forest springs, and surrounding woodlands.
              </p>
              <p className="text-gray-700 leading-relaxed mb-2">
                After an exhilarating game drive enriched by the sights and sounds of the African wilderness, we will depart with cherished 
                memories to last a lifetime.
              </p>
              <p className="text-sm font-semibold text-[#2f4f2f]">Accommodation: Mbuzi Kubu Tented Lodge</p>
            </div>

            {/* Day 4 */}
            <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
              <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 4: Drive to Serengeti National Park</h4>
              <p className="text-gray-700 leading-relaxed mb-2">
                After breakfast, we will continue our journey towards the Kenin highlands where the Iraqw people cultivate wheat and corn. Our 
                route will take us through the misty rainforests of the Ngorongoro Conservation area, where you may catch glimpses of buffaloes, 
                baboons, or even elephants amidst the thick vegetation.
              </p>
              <p className="text-gray-700 leading-relaxed mb-2">
                As we traverse the Ngorongoro Conservation Area, you will be treated to a view of the stunning Ngorongoro Crater before we head 
                onward to the Serengeti National Park, arriving by midday. Serengeti National Park, Tanzania's largest park, boasts a rich tapestry 
                of landscapes, including grassy plains, swamps, lakes, savannas, and mountains. Following an extensive game drive, we will 
                proceed to our accommodation where dinner and a memorable overnight stay await you.
              </p>
              <p className="text-sm font-semibold text-[#2f4f2f]">Accommodation: Mbuzi Kubu Tented Lodge</p>
            </div>

            {/* Day 5 */}
            <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
              <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 5: Full Day Game Drive in Serengeti National Park</h4>
              <p className="text-gray-700 leading-relaxed mb-2">
                The Serengeti offers an extraordinary array of resident wildlife throughout the year, and it's abundantly clear why it requires a 
                more extended stay to truly appreciate its wonders. The Serengeti, renowned for hosting the annual Great Migration, showcases an 
                incredible variety of zebra, antelope, and wildebeest. The Serengeti also hosts a diverse array of wildlife, including impala, buffalo, crocodile, and 
                hippo. The majestic predators of these lands are influenced by careful and well-adapted species balances to encounter. Our 
                journey from the woodland northern regions and hilly areas to the southern grassy plains. During the main rainy season from April to 
                June,
              </p>
              <p className="text-gray-700 leading-relaxed mb-2">
                In addition to the migratory herds, we may encounter resident predators such as leopards, cheetahs, and lions, playing their part in 
                this Serengeti's intricate ecosystem. After an adventurous day of wildlife observation, we will return to the Lodge to relax, enjoy 
                dinner, and sleep amidst the splendor of the Endless Plain.
              </p>
              <p className="text-sm font-semibold text-[#2f4f2f]">Accommodation: Mbuzi Kubu Tented Lodge</p>
            </div>

            {/* Day 6 */}
            <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
              <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 6: Transfer to Ngorongoro Crater</h4>
              <p className="text-gray-700 leading-relaxed mb-2">
                After breakfast, embark on an en-route game drive through the Serengeti, with a chance to spot the African Big Five that is the 
                lions, elephants, buffaloes, rhinos and leopards before continuing your journey to Ngorongoro Crater. This UNESCO World Heritage 
                site, formed millions of years ago, is often MoU as an eighth wonder of the world due to its incredible topography and diverse 
                wildlife population of around 25,000 animals. The Crater offers some of the best game viewing in Tanzania.
              </p>
              <p className="text-gray-700 leading-relaxed mb-2">
                As we arrive near Lake Natron buffalo herds, then descend into the Crater, where you will quickly encounter wildebeest, zebras, 
                gazelles, elephants, and over 500 bird species. With some luck, you might even spot the endangered black rhino among the 
                acacia trees.
              </p>
              <p className="text-gray-700 leading-relaxed mb-2">
                Following such a brief afternoon exploring the Crater, you will proceed to your accommodation for dinner and an overnight stay.
              </p>
              <p className="text-sm font-semibold text-[#2f4f2f]">Accommodation: Lake Manyara Kilimambo Lodge</p>
            </div>

            {/* Day 7 */}
            <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
              <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 7: Karatu to Zanzibar</h4>
              <p className="text-gray-700 leading-relaxed mb-2">
                You will be picked up from your accommodation and driven directly to the airport to catch your flight to Zanzibar. Your first night 
                will be spent at Stone Town, where you can relax and enjoy stunning views of this historic city.
              </p>
              <p className="text-gray-700 leading-relaxed mb-2">
                Optional activities can be arranged, including a guided tour of the Old Town, a Spice Tour, or a visit to Prison Island. Additionally, a tour 
                to Jozani Forest can be organized.
              </p>
              <p className="text-sm font-semibold text-[#2f4f2f]">Accommodation: Zanzibar Serena Hotel</p>
            </div>

            {/* Day 8-11 */}
            <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
              <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 8 – 11: Stone Town to North Coast (Nungwi)</h4>
              <p className="text-gray-700 leading-relaxed mb-2">
                Nungwi, nestled in the northern expanse of the island, emerges as a vibrant village enriched by Zanzibar's pristine beaches. Your 
                journey will lead you to this enchanting locale, roughly 55 km away from Stone Town.
              </p>
              <p className="text-gray-700 leading-relaxed mb-2">
                Evolving from its roots as a prominent fishing community, Nungwi has blossomed into a sought-after island retreat teeming with 
                vitality. Notably, it stands as one of the few spots where the spectacle of both sunrise and sunset gracing the ocean can be 
                witnessed. Here, amidst the breathtaking backdrop of ivory sands and the azure embrace of the Indian Ocean, indulge in moments 
                of tranquility and captivating oceanic charm of ocean hours.
              </p>
              <p className="text-sm font-semibold text-[#2f4f2f]">Accommodation: Melia Zanzibar</p>
            </div>

            {/* Day 12 */}
            <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
              <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 12: Departure</h4>
              <p className="text-gray-700 leading-relaxed mb-2">
                Spend your final hours unwinding at leisure. At a suitable time, you'll be transported to the airport, ensuring you arrive in time for 
                your flight.
              </p>
              <p className="text-sm font-semibold text-[#2f4f2f]">Inclusions</p>
            </div>
          </div>

          {/* Right Side - Tour Details Box */}
          <div className="w-full md:w-80 p-4">
            <div className="bg-white border border-[#9acd32]/20 rounded-lg p-4">
              <div className="text-center mb-3">
                <div className="text-lg font-bold text-[#2f4f2f]">12 Days Tanzania</div>
                <div className="text-lg font-bold text-[#2f4f2f]">Zanzibar Beach Tour</div>
                <div className="text-sm text-gray-600 mt-1">Duration</div>
                <div className="text-sm text-gray-700">12 Days / 11 Nights safari</div>
                <div className="text-sm text-gray-600 mt-2">Departure / Return</div>
                <div className="text-sm text-gray-700">Every day - Year-round activity</div>
              </div>
              
              <div className="bg-[#2f4f2f] text-white text-center py-2 rounded mb-3 font-semibold">
                Plan Your Trip Now
              </div>
              
              <div className="text-center">
                <div className="text-sm text-gray-600 mb-1">Call/WhatsApp us for Free Cost</div>
                <div className="text-lg font-bold text-[#2f4f2f]">
                  <Phone className="inline mr-2" size={20} />
                  <a href="tel:+255753182737" className="text-[#9acd32] hover:text-[#228b22] transition-colors">+255 753 182 737</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Inclusions & Exclusions */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h3 className="text-lg font-bold text-[#2f4f2f] mb-3">Inclusions</h3>
            <ul className="text-sm text-gray-700 space-y-1">
              <li>• Transportation on a 4 x 4 safari vehicle with a pop-up roof</li>
              <li>• Accommodations and meals as stated</li>
              <li>• Entrance fees to all National Parks</li>
              <li>• En-route lunches</li>
              <li>• Bottled water</li>
              <li>• Professional English speaking driver guide</li>
              <li>• English Driver guide</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold text-[#2f4f2f] mb-3">Exclusions</h3>
            <ul className="text-sm text-gray-700 space-y-1">
              <li>• Visa Fees & flights</li>
              <li>• Optional activities</li>
              <li>• Travel insurance</li>
              <li>• Laundry</li>
              <li>• Alcoholic drinks</li>
              <li>• Beverages, soft/alcoholic drinks & tips</li>
              <li>• Health tour requirements</li>
              <li>• Personal travel insurance</li>
              <li>• Items of personal nature</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwelveDays;